import {
  ACCESSIBILITY_PATH,
  COMPANY_INFORMATION_PATH,
  CUSTOMER_SERVICE_SUBDOMAIN,
  PRIVACY_PATH,
  TERMS_AND_CONDITIONS,
} from '@/config/constants'

export default [
  {
    id: 'terms',
    key: 'terms_and_conditions',
    baseUrl: CUSTOMER_SERVICE_SUBDOMAIN,
    path: TERMS_AND_CONDITIONS,
  },

  {
    id: 'privacy',
    key: 'privacy_policy',
    baseUrl: CUSTOMER_SERVICE_SUBDOMAIN,
    path: PRIVACY_PATH,
  },
  {
    id: 'accessibility',
    key: 'accessibility',
    baseUrl: CUSTOMER_SERVICE_SUBDOMAIN,
    path: ACCESSIBILITY_PATH,
  },

  {
    id: 'imprint',
    key: 'imprint',
    baseUrl: CUSTOMER_SERVICE_SUBDOMAIN,
    path: COMPANY_INFORMATION_PATH,
  },
]
